module.exports = __webpack_public_path__ + "static/media/video.7a5bb104.jpg";